import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterLink} from '@angular/router';
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {DialogService} from "../../../_modal/dialog.service";
import { AbstractControl,FormBuilder,FormGroup,ReactiveFormsModule, ValidationErrors,Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {PocDTO} from "../../../_models/Contact";
import {PocService} from "../../../../services/poc-service/poc.service";
import {HandleErrorsService} from "../../../../services/handle-erros/handle.errors.service";
import {ClientsService} from "../../../../services/client-service/clients.service";
import {ClientDto} from "../../../_models/client.dtos";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {CookieService} from "ngx-cookie-service";

@Component({
    selector: 'app-client-poc-list',
    standalone: true,
    providers: [HandleErrorsService, ApiService, Endpoints, DialogService, PocService, ClientsService],
    imports: [
        MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
        MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatDatepicker,
        MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, NgForOf, DatePipe, MatCheckbox
    ],
    templateUrl: './clients-poc-list.component.html',
    styleUrl: './clients-poc-list.component.scss'
})
export class ClientPOCListComponent implements OnInit, AfterViewInit {
    @Input() clientsPoc: any[] = [];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<any>;
    @ViewChild('viewModal') viewModal: TemplateRef<any>;
    editForm: FormGroup;
    form: FormGroup;
    clientList: ClientDto[]
    dataSource = new MatTableDataSource<PocDTO>();
    searchValue: string = ''
    poc?: PocDTO
    loadingTable: boolean = true;

    displayedColumns: string[] = ['name', 'firstName', 'client', 'address', 'postalCode', 'city', 'job', 'phone','mobilePhone'];
    columns: string[] = [...this.displayedColumns];
    columnLabels: Record<string, string> = {
        name: 'Nom',
        firstName: 'Prénom',
        client: 'Client',
        address: 'Adresse',
        postalCode: 'Code postal',
        city: 'Ville',
        job: 'Fonction',
        phone: 'Téléphone',
        mobilePhone: 'Mobile',
    };
    constructor(
        private cookieService: CookieService,
        private handleErrorsService: HandleErrorsService,
        private pocService: PocService,
        private clientService: ClientsService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private overlayContainer: OverlayContainer) {
    }

    ngOnInit(): void {
        this.fetchPOCList()
        this.initializeEditForm();
        this.fetchClientList();
        this.initializeCreateForm()
        this.getColsCookie()
    }

    fetchPOCList() {
        this.pocService.findAll().subscribe({
            next: response => {    
                if (response.status) {
                    this.dataSource.data = response.data;
                    this.loadingTable = false;
                }
            },
            error: err => console.error("❌ Erreur lors de la récupération des POCs :", err) // Ajout pour voir les erreurs éventuelles
        });
    }
    

    ngAfterViewInit() {
        this.initializePaginatorAndSort();
    }

    private initializePaginatorAndSort() {
        this.dataSource.filter = this.searchValue
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'asc';
        this.overlayContainer.getContainerElement().style.zIndex = '2000';
    }

    initializeEditForm() {
        this.editForm = this.fb.group({
            id: ['', Validators.required],
            name: ['', Validators.required],
            firstName: ['', Validators.required],
            address: ['', Validators.required],
            postalCode: ['', Validators.required],
            city: ['', Validators.required],
            job: ['', Validators.required],
            phone: ['', [Validators.required, Validators.pattern(/^\+?\d{1,3}[-\s]?\d{10}$/)]],
            mobilePhone: ['', [Validators.required, Validators.pattern(/^\+?\d{1,3}[-\s]?\d{10}$/)]],
            email: ['', [Validators.required, Validators.email]],
            flag: ['', Validators.required],
            clientId: [null, Validators.required],
            userId: [null, Validators.required],
            notes: [''],
        });
    }

    initializeCreateForm() {
        this.form = this.fb.group({
            name: ['', Validators.required],
            firstName: ['', Validators.required],
            address: ['', Validators.required],
            postalCode: ['', Validators.required],
            city: ['', Validators.required],
            job: ['', Validators.required],
            phone: ['', [Validators.required, Validators.pattern(/^\+?\d{1,3}[-\s]?\d{10}$/)]],
            mobilePhone: ['', [Validators.required, Validators.pattern(/^\+?\d{1,3}[-\s]?\d{10}$/)]],
            email: ['', [Validators.required, Validators.email]],
            flag: [1, Validators.required],
            clientId: [null, Validators.required],
            notes: [''],
        });
    }
    public phoneValidator(control: AbstractControl): ValidationErrors | null {
        const validPhonePattern = /^[+\d][\d\s-]*$/;
        return validPhonePattern.test(control.value) ? null : { invalidPhone: true };
    }

    getClientName(clientId: number): string {
        const client = this.clientList.find(client => client.id === clientId);
        return client?.socialReason ?? 'N/A';  // Utilisation de l'opérateur "??" pour éviter "undefined"
    }
      
      
    openEditModal(element: PocDTO) {
        console.log(element)
        this.editForm.patchValue(element);
        this.modalService.open(this.editModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    }

    private fetchClientList() {
        this.clientService.loadClients().subscribe({
            next: response => {
                if(response.status){
                    this.clientList = response.data
                }
            }
        })
    }

    onClientSelected(clientId: number): void {
        const selectedClient = this.clientList.find(client => client.id === clientId);
        
        if (selectedClient) {
          this.form.patchValue({
            address: selectedClient.address,
            
          });
        }
      }
      onClientSelected1(clientId: number): void {
        const selectedClient = this.clientList.find(client => client.id === clientId);
        
        if (selectedClient) {
          this.editForm.patchValue({
            address: selectedClient.address,
        
          });
        }
      }
    savePoc(): void {
        if (this.form.valid) {
            console.log("✅ Client sélectionné :", this.form.value.clientId); // Vérification 
            this.pocService.save(this.form.value).subscribe({
                next: response => {
                    if (response.status) {
                        let poc: PocDTO = response.data;
                        this.dataSource.data = [...this.dataSource.data, poc];
                        this.form.reset();
                        this.modalService.dismissAll();
                        this.dialogService.openSuccessDialog(response.message);
                    } else {
                        this.dialogService.openDangerDialog(response.message);
                    }
                },
                error: err => {
                    console.error("❌ Erreur API :", err);
                }
            });
        } else {
            this.dialogService.openInvalidFormDialog();
        }
    } 
    updatePoc() {
        if (this.editForm.valid) {
            const formData = this.editForm.value;

            this.pocService.update(formData).subscribe({
                next: response => {
                    if (response.status) {
                        this.updateTableRow(response.data)
                        this.modalService.dismissAll()
                        this.dialogService.openSuccessDialog(response.message)
                    } else {
                        this.dialogService.openDangerDialog(response.message)
                    }
                },
                error: err => this.handleErrorsService.catchError(err),
                complete: () => this.initializePaginatorAndSort()
            })
        } else {
            this.dialogService.openInvalidFormDialog()
        }
    }

    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
            this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
        }
    }

    confirmDelete(element: any) {
        this.dialogService.confirm('Etes-vous sûr de vouloir supprimer ce client poc?')
            .then((result: any) => {
                if (result) {
                    this.deleteClient(element.id);
                }
            });
    }
    deleteClient(id: number) {
        this.pocService.delete(id).subscribe({
            next: response => {
                if (response) {
                    this.removeTableRow(id);
                    this.dialogService.openSuccessDialog('Contact supprimé avec succès')
                }
            },
            error : err => this.handleErrorsService.catchError(err),
            complete: () => this.initializePaginatorAndSort()
        });
    }

    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        this.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase()
        this.dataSource.filter = this.searchValue
    }

    openViewModel(element: PocDTO) {
        this.poc = element
        this.modalService.open(this.viewModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});

    }
    openModal(content: any) {
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg'}).result.then(
            () => {
                this.form.reset()
            },
            () => {
                this.form.reset()
            }
        );
    }
    handleIsAllColsSelected(event: MatCheckboxChange) {
        if (event.checked) {
            this.displayedColumns = [...this.columns]
        } else {
            this.displayedColumns = []
        }
        this.setColsCookie()
    }

    getdisplayedCol = (): string[] => {
        return [...this.displayedColumns, 'action']
    };
    onSelectionChange(column: string): void {
        if (this.displayedColumns.includes(column)) {
            this.displayedColumns = this.displayedColumns.filter(c => c !== column);
        } else {
            this.displayedColumns.push(column)
        }
        this.setColsCookie()
    }

    user_name = sessionStorage.getItem('user_name');

    private setColsCookie() {
        this.cookieService.set(`poc_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }
    private getColsCookie() {
        const sampleCols = this.cookieService.get(`poc_${this.user_name}`); // Get the cookie value

        if (sampleCols) {
            this.displayedColumns = JSON.parse(sampleCols); // Convert the JSON string back to an object
            console.log('Retrieved object:', sampleCols);
        }
    }
}

